import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
  editStudentProfile,
  IMG_BASE_URL,
  StudentProfile,
} from '../../../AllAPI/StudentAPI'
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Upload,
  Spin,
} from 'antd'
import { EditOutlined, UploadOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { toast } from 'react-toastify'

const { Option } = Select

const ProfileDetails = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [isEdit, setIsEdit] = useState(false)
  const [editForm] = Form.useForm()
  const [editLoading, setEditLoading] = useState(false)

  // File states
  const [sPic, setSPic] = useState(null)
  const [castIncomeCert, setCastIncomeCert] = useState(null)
  const [recommendationLetter, setRecommendationLetter] = useState(null)
  const [clgAddReceipt, setClgAddReceipt] = useState(null)
  const [sAadhar, setSAadhar] = useState(null)

  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const RegId = formDataFromStorage.reg_id
  const BoardingYear = formDataFromStorage.year

  const formatDate = (dateString) => {
    if (!dateString) return '-'
    const d = new Date(dateString)
    return d.toLocaleDateString('en-GB')
  }

  useEffect(() => {
    fetchProfile()
  }, [])

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${StudentProfile}/${RegId}/${BoardingYear}`)
      setData(res.data)
    } catch (err) {
      console.log('Error:', err)
    }
    setLoading(false)
  }

  // Pre-fill edit form with existing profile data
  const handleOpenEdit = () => {
    if (data) {
      editForm.setFieldsValue({
        s_fname: data.s_fname,
        s_mname: data.s_mname,
        s_lname: data.s_lname,
        date_of_birth: data.date_of_birth ? dayjs(data.date_of_birth) : null,
        email: data.email,
        wh_mobile: data.wh_mobile,
        mobile: data.mobile,
        blood_grp: data.blood_grp,
        religion_id: data.religion_id,
        cast_id: data.cast_id,
        address: data.address,
        village: data.village,
        pin: data.pin,
        state: data.state,
        district: data.district,
        taluka: data.taluka,
        // Academic
        last_attended_clg_name: data.last_attended_clg_name,
        highest_qualification: data.highest_qualification,
        aggre_percentage: data.aggre_percentage,
        month_year_of_passing: data.month_year_of_passing,
        curr_yr_clg_name: data.curr_yr_clg_name,
        course_name: data.course_name,
        total_course_duration: data.total_course_duration,
        remaining_course_duration: data.remaining_course_duration,
        specific_degree: data.specific_degree,
        // Father
        father_fname: data.father_fname,
        father_mname: data.father_mname,
        father_lname: data.father_lname,
        father_mob: data.father_mob,
        father_age: data.father_age,
        father_occ: data.father_occ,
        // Mother
        mother_fname: data.mother_fname,
        mother_mname: data.mother_mname,
        mother_lname: data.mother_lname,
        mother_mob: data.mother_mob,
        mother_age: data.mother_age,
        mother_occ: data.mother_occ,
        // Emergency
        emergency_name: data.emergency_name,
        emergency_contact: data.emergency_contact,
        total_family_mamber: data.total_family_mamber,
        // Chairman
        chairman_name: data.chairman_name,
        chairman_mob: data.chairman_mob,
        chairman_village: data.chairman_village,
        // Reference
        reference_name: data.reference_name,
        reference_mobile: data.reference_mobile,
        reference_relation: data.reference_relation,
        // Guardian
        local_guardian_name: data.local_guardian_name,
        local_guardian_mobile: data.local_guardian_mobile,
        local_guardian_address: data.local_guardian_address,
        year: data.year,
      })
    }
    setIsEdit(true)
  }

  const handleEditSubmit = async () => {
    try {
      const values = await editForm.validateFields()
      setEditLoading(true)

      const formData = new FormData()

      const fields = {
        s_fname: values.s_fname,
        s_mname: values.s_mname,
        s_lname: values.s_lname,
        date_of_birth: values.date_of_birth
          ? dayjs(values.date_of_birth).format('YYYY-MM-DD')
          : '',
        email: values.email,
        wh_mobile: values.wh_mobile,
        mobile: values.mobile,
        blood_grp: values.blood_grp,
        religion_id: values.religion_id,
        cast_id: values.cast_id,
        address: values.address,
        village: values.village,
        pin: values.pin,
        state: values.state,
        district: values.district,
        taluka: values.taluka,
        last_attended_clg_name: values.last_attended_clg_name,
        highest_qualification: values.highest_qualification,
        aggre_percentage: values.aggre_percentage,
        month_year_of_passing: values.month_year_of_passing,
        curr_yr_clg_name: values.curr_yr_clg_name,
        course_name: values.course_name,
        total_course_duration: values.total_course_duration,
        remaining_course_duration: values.remaining_course_duration,
        specific_degree: values.specific_degree,
        father_fname: values.father_fname,
        father_mname: values.father_mname,
        father_lname: values.father_lname,
        father_mob: values.father_mob,
        father_age: values.father_age,
        father_occ: values.father_occ,
        mother_fname: values.mother_fname,
        mother_mname: values.mother_mname,
        mother_lname: values.mother_lname,
        mother_mob: values.mother_mob,
        mother_age: values.mother_age,
        mother_occ: values.mother_occ,
        emergency_name: values.emergency_name,
        emergency_contact: values.emergency_contact,
        total_family_mamber: values.total_family_mamber,
        chairman_name: values.chairman_name,
        chairman_mob: values.chairman_mob,
        chairman_village: values.chairman_village,
        reference_name: values.reference_name,
        reference_mobile: values.reference_mobile,
        reference_relation: values.reference_relation,
        local_guardian_name: values.local_guardian_name,
        local_guardian_mobile: values.local_guardian_mobile,
        local_guardian_address: values.local_guardian_address,
        year: values.year,
      }

      Object.entries(fields).forEach(([key, val]) => {
        formData.append(key, val || '')
      })

      if (sPic) formData.append('s_pic', sPic)
      if (castIncomeCert) formData.append('cast_income_cert', castIncomeCert)
      if (recommendationLetter)
        formData.append('recommendation_letter', recommendationLetter)
      if (clgAddReceipt) formData.append('clg_add_receipt', clgAddReceipt)
      if (sAadhar) formData.append('s_aadhar', sAadhar)

      await axios.put(`${editStudentProfile}/${RegId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      toast.success('Profile updated successfully!')
      setIsEdit(false)
      fetchProfile() // Refresh data after update
    } catch (error) {
      console.error(error)
      if (error?.errorFields) {
        toast.warn('Please fill all required fields.')
      } else {
        toast.error('Update failed. Please try again.')
      }
    } finally {
      setEditLoading(false)
    }
  }

  const fileUploadProps = (setter) => ({
    beforeUpload: (file) => {
      setter(file)
      return false
    },
    maxCount: 1,
  })

  const SectionTitle = ({ title }) => (
    <h5
      className="mb-3 p-0 mt-2"
      style={{
        color: '#235784',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '6px',
      }}
    >
      {title}
    </h5>
  )

  if (loading) return <h4 className="text-center mt-5">Loading...</h4>
  if (!data) return <h4 className="text-center mt-5">No Profile Found</h4>

  const docs = data.documents || {}
  const payment = data.payment || {}
  const room = data.roombooking || {}

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-lg-2"></div>
        <div className="col-12 col-lg-8">
          {/* Header with Edit Button */}
          <div className="header-row d-flex justify-content-between align-items-center mb-3">
            <h2 className="page-title">Student Profile Details</h2>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={handleOpenEdit}
              style={{
                background: 'linear-gradient(115deg, #242443, #162e29)',
                border: 'none',
              }}
            >
              Edit
            </Button>
          </div>

          {/* ========================= PERSONAL INFO ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Personal Information -
              </h5>

              <div className="col-12 col-md-4 text-center border rounded shadow pt-2">
                <img
                  src={`${IMG_BASE_URL}${docs.s_pic}`}
                  alt="Student"
                  className="rounded-circle shadow"
                  style={{
                    width: '160px',
                    height: '160px',
                    objectFit: 'cover',
                    border: '3px solid #ddd',
                  }}
                />
                <h4
                  className="mt-3 px-2 rounded"
                  style={{ backgroundColor: '#fdf07bff' }}
                >
                  {`${data.s_fname} ${data.s_mname} ${data.s_lname}`}
                </h4>
              </div>

              <div className="col-12 col-md-8">
                <div className="row">
                  {[
                    ['Date of Birth', data.date_of_birth],
                    ['Email', data.email],
                    ['WhatsApp No', data.wh_mobile],
                    ['Mobile', data.mobile],
                  ].map(([label, value]) => (
                    <div className="col-12 col-md-6 mb-3" key={label}>
                      <span style={{ fontWeight: '500' }}>{label}:</span>
                      <p className="border rounded p-2 bg-light">{value}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-12 pt-2">
                <div className="row">
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>Religion:</span>
                    <p className="border rounded p-2 bg-light">
                      {data.religion.religion_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>Caste:</span>
                    <p className="border rounded p-2 bg-light">
                      {data.castname.cast_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>Blood Group:</span>
                    <p className="border rounded p-2 bg-light">
                      {data.blood_grp}
                    </p>
                  </div>
                  <div className="col-12 mb-3">
                    <span style={{ fontWeight: '500' }}>Address:</span>
                    <p className="border rounded p-2 bg-light">
                      {data.address}, {data.village}, Pin: {data.pin}, State:{' '}
                      {data.location.stateenname} District:{' '}
                      {data.location.districtenname} Taluka:{' '}
                      {data.location.talukaenname}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= ACADEMIC INFO ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Academic Information -
              </h5>
              <div className="row">
                {[
                  [
                    'Name of School / College Last Attended',
                    data.last_attended_clg_name,
                  ],
                  [
                    'Highest Qualification Obtained',
                    data.highest_qualification,
                  ],
                  ['Aggregate Percentage (%)', data.aggre_percentage],
                  ['Month & Year of Passing', data.month_year_of_passing],
                  [
                    'Name of Institution Currently Enrolled In',
                    data.curr_yr_clg_name,
                  ],
                  ['Course / Program Name', data.course_name],
                  ['Total Course Duration', data.total_course_duration],
                  [
                    'Remaining Duration of Course',
                    data.remaining_course_duration,
                  ],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= FATHER DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Father Details -
              </h5>
              <div className="row">
                {[
                  [
                    'Full Name',
                    `${data.father_fname} ${data.father_mname} ${data.father_lname}`,
                  ],
                  ['Mobile', data.father_mob],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
                <div className="col-12 pt-2">
                  <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>Age:</span>
                      <p className="border rounded p-2 bg-light">
                        {data.father_age}
                      </p>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>Occupation:</span>
                      <p className="border rounded p-2 bg-light">
                        {data.father_occ}
                      </p>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>Family Members:</span>
                      <p className="border rounded p-2 bg-light">
                        {data.total_family_mamber}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= MOTHER DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Mother Details -
              </h5>
              <div className="row">
                {[
                  [
                    'Full Name',
                    `${data.mother_fname} ${data.mother_mname} ${data.mother_lname}`,
                  ],
                  ['Mobile', data.mother_mob],
                  ['Age', data.mother_age],
                  ['Occupation', data.mother_occ],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= CHAIRMAN DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Chairman Details -
              </h5>

              <div className="row">
                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Chairman Name:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.chairman_name}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Chairman Mobile:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.chairman_mob}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Chairman Village:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.chairman_village}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= REFERENCE DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Reference Details -
              </h5>

              <div className="row">
                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Reference Name:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.reference_name}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Reference Mobile:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.reference_mobile}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Reference Relation:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.reference_relation}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= LOCAL GUARDIAN DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Local Guardian Details -
              </h5>

              <div className="row">
                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Guardian Name:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.local_guardian_name}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Guardian Mobile:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.local_guardian_mobile}
                  </p>
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <span style={{ fontWeight: '500' }}>Guardian Address:</span>
                  <p className="border rounded p-2 bg-light">
                    {data.local_guardian_address}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= EMERGENCY DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Emergency Details -
              </h5>
              <div className="row">
                {[
                  ['Full Name', data.emergency_name],
                  ['Mobile', data.emergency_contact],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= DOCUMENTS SECTION ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <h5 className="mb-3" style={{ color: '#235784' }}>
              Documents -
            </h5>
            <div className="row text-center">
              {Object.entries({
                'Aadhar Card': docs.s_aadhar,
                '10th / 12th Leaving Certificate': docs.cast_income_cert,
                'Recommendation Letter': docs.recommendation_letter,
                'College Admission Receipt': docs.clg_add_receipt,
              }).map(([label, fileName]) => {
                const imgSrc = fileName ? IMG_BASE_URL + fileName : null
                return (
                  <div
                    className="col-12 col-md-6 col-lg-4 mb-3 mt-3 pb-4"
                    style={{ border: '1px solid #b8b8b8ff' }}
                    key={label}
                  >
                    <p className="fw-semibold mb-1">{label}</p>
                    {imgSrc ? (
                      fileName.toLowerCase().endsWith('.pdf') ? (
                        <>
                          <iframe
                            src={imgSrc}
                            title={label}
                            width="100%"
                            height="300px"
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: '6px',
                            }}
                          />
                          <a
                            href={imgSrc}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary mt-2"
                          >
                            Download PDF
                          </a>
                        </>
                      ) : (
                        <img
                          src={imgSrc}
                          alt={label}
                          className="img-fluid rounded border"
                          style={{
                            width: '100%',
                            objectFit: 'contain',
                            display: 'block',
                          }}
                        />
                      )
                    ) : (
                      <p className="text-muted">No File</p>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-2"></div>
      </div>

      {/* ========================= EDIT MODAL ============================= */}
      <Modal
        title="Edit Student Profile"
        open={isEdit}
        onCancel={() => setIsEdit(false)}
        onOk={handleEditSubmit}
        okText={editLoading ? 'Updating...' : 'Update'}
        confirmLoading={editLoading}
        width={900}
        styles={{
          body: { maxHeight: '70vh', overflowY: 'auto', paddingRight: 8 },
        }}
      >
        <Form form={editForm} layout="vertical" autoComplete="off">
          {/* Personal Info */}
          <SectionTitle title="Personal Information" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="s_fname"
                label="First Name"
                rules={[{ required: true, message: 'Required' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="s_mname" label="Middle Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="s_lname"
                label="Last Name"
                rules={[{ required: true, message: 'Required' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="date_of_birth" label="Date of Birth">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="blood_grp" label="Blood Group">
                <Select placeholder="Select">
                  {['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'].map(
                    (bg) => (
                      <Option key={bg} value={bg}>
                        {bg}
                      </Option>
                    ),
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="religion_id" label="Religion ID">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="cast_id" label="Cast ID">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Contact */}
          <SectionTitle title="Contact Information" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="mobile"
                label="Mobile"
                rules={[{ required: true, message: 'Required' }]}
              >
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="wh_mobile" label="WhatsApp Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'Valid email required',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Address */}
          <SectionTitle title="Address" />
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name="address" label="Address">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item name="village" label="Village">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item name="pin" label="PIN Code">
                <Input maxLength={6} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="state" label="State ID">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="district" label="District ID">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="taluka" label="Taluka ID">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Education */}
          <SectionTitle title="Academic Information" />
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name="curr_yr_clg_name" label="Current College Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="last_attended_clg_name"
                label="Last Attended College"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="highest_qualification"
                label="Highest Qualification"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="specific_degree" label="Specific Degree">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="aggre_percentage" label="Aggregate %">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="month_year_of_passing"
                label="Month/Year of Passing"
              >
                <Input placeholder="e.g. 05/2024" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="course_name" label="Course Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item
                name="total_course_duration"
                label="Total Duration (Yrs)"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item
                name="remaining_course_duration"
                label="Remaining (Yrs)"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item name="year" label="Year">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Father */}
          <SectionTitle title="Father's Details" />
          <Row gutter={16}>
            {['fname', 'mname', 'lname'].map((f) => (
              <Col xs={24} sm={8} key={f}>
                <Form.Item
                  name={`father_${f}`}
                  label={`Father ${
                    f === 'fname' ? 'First' : f === 'mname' ? 'Middle' : 'Last'
                  } Name`}
                >
                  <Input />
                </Form.Item>
              </Col>
            ))}
            <Col xs={24} sm={8}>
              <Form.Item name="father_mob" label="Father Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="father_age" label="Father Age">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="father_occ" label="Father Occupation">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Mother */}
          <SectionTitle title="Mother's Details" />
          <Row gutter={16}>
            {['fname', 'mname', 'lname'].map((f) => (
              <Col xs={24} sm={8} key={f}>
                <Form.Item
                  name={`mother_${f}`}
                  label={`Mother ${
                    f === 'fname' ? 'First' : f === 'mname' ? 'Middle' : 'Last'
                  } Name`}
                >
                  <Input />
                </Form.Item>
              </Col>
            ))}
            <Col xs={24} sm={8}>
              <Form.Item name="mother_mob" label="Mother Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="mother_age" label="Mother Age">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="mother_occ" label="Mother Occupation">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Emergency */}
          <SectionTitle title="Emergency & Family" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item name="emergency_name" label="Emergency Contact Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="emergency_contact" label="Emergency Contact No.">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="total_family_mamber"
                label="Total Family Members"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Chairman & Reference */}
          <SectionTitle title="Chairman & Reference" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item name="chairman_name" label="Chairman Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="chairman_mob" label="Chairman Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="chairman_village" label="Chairman Village">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="reference_name" label="Reference Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="reference_mobile" label="Reference Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="reference_relation" label="Reference Relation">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Local Guardian */}
          <SectionTitle title="Local Guardian" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item name="local_guardian_name" label="Guardian Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="local_guardian_mobile" label="Guardian Mobile">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item name="local_guardian_address" label="Guardian Address">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Documents */}
          <SectionTitle title="Documents (Upload only if replacing)" />
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item label="Student Photo">
                <Upload {...fileUploadProps(setSPic)} accept="image/*">
                  <Button icon={<UploadOutlined />}>Upload Photo</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="10th / 12th Leaving Certificate">
                <Upload {...fileUploadProps(setCastIncomeCert)}>
                  <Button icon={<UploadOutlined />}>Upload Certificate</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="Recommendation Letter">
                <Upload {...fileUploadProps(setRecommendationLetter)}>
                  <Button icon={<UploadOutlined />}>Upload Letter</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="College Admission Receipt">
                <Upload {...fileUploadProps(setClgAddReceipt)}>
                  <Button icon={<UploadOutlined />}>Upload Receipt</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="Aadhar Card">
                <Upload {...fileUploadProps(setSAadhar)}>
                  <Button icon={<UploadOutlined />}>Upload Aadhar</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  )
}

export default ProfileDetails
